/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_S1_Li1Inputs */

const en_guide_json_vs_yaml_xml_s1_li1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S1_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>JSON</strong>: Lightweight, fast parsing, native JavaScript support, widely used in web APIs`)
};

const ko_guide_json_vs_yaml_xml_s1_li1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S1_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>JSON</strong>: 경량, 빠른 파싱, JavaScript 네이티브 지원, 웹 API에서 널리 사용`)
};

const ja_guide_json_vs_yaml_xml_s1_li1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S1_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>JSON</strong>: 軽量、高速なパース、JavaScriptネイティブサポート、Web APIで広く使用`)
};

/**
* | output |
* | --- |
* | "<strong>JSON</strong>: Lightweight, fast parsing, native JavaScript support, widely used in web APIs" |
*
* @param {Guide_Json_Vs_Yaml_Xml_S1_Li1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_s1_li1 = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_S1_Li1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_S1_Li1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_s1_li1(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_s1_li1(inputs)
	return ja_guide_json_vs_yaml_xml_s1_li1(inputs)
});